import { render, staticRenderFns } from "./Sponsers.vue?vue&type=template&id=1d6ee9b1&scoped=true&"
import script from "./Sponsers.vue?vue&type=script&lang=js&"
export * from "./Sponsers.vue?vue&type=script&lang=js&"
import style0 from "./Sponsers.vue?vue&type=style&index=0&id=1d6ee9b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6ee9b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VImg,VRow})
